import {configureStore} from '@reduxjs/toolkit';
import {availabilitySlice} from './slices/availability/slice';
import {channelSlice} from './slices/channel/slice';
import {venueSlice} from './slices/venue/slice';
import {rescheduleSlice} from './slices/reschedule/slice';
import {configSlice} from './slices/config/slice';

export const store = configureStore({
  reducer: {
    availability: availabilitySlice.reducer,
    reschedule: rescheduleSlice.reducer,
    channel: channelSlice.reducer,
    venue: venueSlice.reducer,
    config: configSlice.reducer,
  },
});
